import { useCallback, useMemo } from 'react'
import { Box, Button, Flex, Spacer, Tag } from '@chakra-ui/react'
import ColumnEditButton from './ColumnEditButton/ColumnEditButton'
import { isNullish } from '@/utils/helper'
import { useTranslation } from 'react-i18next'
// import { RxCross2 } from 'react-icons/rx';

const TableToolbar = ({ table }) => {
  const { columnFilters } = table.getState()
  const { t } = useTranslation()

  const handleClearAllFilter = () => {
    table.setColumnFilters([])
  }

  const handleDeleteFilter = (id) => {
    table.setColumnFilters((oldFilter) => oldFilter.filter((fil) => fil.id !== id))
  }

  const getColumnLabelById = useCallback(
    (columnId) => {
      const selectedColumn = table.getColumn(columnId)

      if (isNullish(selectedColumn)) {
        return columnId
      }

      return selectedColumn?.columnDef?.header({ header: { id: columnId } })
    },
    [table]
  )

  const getFilterValue = (value) => {
    // const { t } = useTranslation()

    if (isNullish(value)) {
      return ''
    }
    if (Array.isArray(value) && value.length > 1) {
      return <Tag colorScheme="teal">{value.length}</Tag>
    }

    return <Tag colorScheme="teal">{t(value)}</Tag>
  }
  return (
    <Flex mb={3}>
      <Flex gap="3">
        <Button p="2" borderRadius={10} size="sm" onClick={handleClearAllFilter} variant={'solid'}>
          {t('TABLE_CLEAR_ALL')}
        </Button>
        {columnFilters.map((filter) => (
          <Button
            key={filter.id}
            p="2"
            borderRadius={10}
            size="sm"
            colorScheme="teal"
            onClick={() => handleDeleteFilter(filter.id)}
          >
            <Flex gap="2" alignItems={'center'}>
              {getColumnLabelById(filter?.id)} {getFilterValue(filter?.value)}
            </Flex>
          </Button>
        ))}
      </Flex>

      <Spacer />

      <ColumnEditButton table={table} />
    </Flex>
  )
}

export default TableToolbar
